import React from 'react';
import errorBoundary from '@ifeng/errorBoundary';
import Style from './index.css';
import Divider from '@src/common/components/Divider';

const LINKS = [
    { text: '凤凰新媒体介绍', url: 'https://www.ifeng.com/corp/about/intro/' },
    { text: '投资者关系 Investor Relations', url: 'https://ir.ifeng.com/' },
    { text: '广告服务', url: 'https://biz.ifeng.com/' },
    { text: '诚征英才', url: 'https://career.ifeng.com/' },
    { text: '保护隐私权', url: 'https://www.ifeng.com/corp/privacy/' },
    { text: '免责条款', url: 'https://www.ifeng.com/corp/exemption/' },
    { text: '意见反馈', url: 'https://help.ifeng.com/' },
    { text: '凤凰卫视介绍', url: 'https://phtv.ifeng.com/intro/' },
];

const Footer = () => {
    return (
        <div style={{ marginTop: '46px' }}>
            <Divider />
            <div className={Style.footer} >
                <div className={Style.links}>
                    {
                        LINKS.map((link, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <a href={link.url}>{link.text}</a>
                                    {
                                        index < LINKS.length - 1 &&
                                        <span className={Style.divider}>|</span>
                                    }
                                </React.Fragment>
                            );
                        })
                    }
                </div>
                <div>
                    <span className={Style.span}>凤凰新媒体</span>
                    <span className={Style.span}>版权所有</span>
                    Copyright © 2022 Phoenix New Media Limited All Rights Reserved.
                </div>
            </div>
        </div>
    );
};

export default errorBoundary(Footer);
